var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Container, RadioContainer, Radio, Label, RadioItem, RadioLabel, ErrorWrapper, } from "./RadioList.styles";
import { Field } from "formik";
export var RadioList = function (_a) {
    var _b = _a.label, label = _b === void 0 ? "" : _b, options = _a.options, selected = _a.selected, props = __rest(_a, ["label", "options", "selected"]);
    var radioListId = props.id || props.name + "-Radio";
    var containerId = radioListId + "-Container";
    return (React.createElement(Field, __assign({}, props, { id: containerId }), function (_a) {
        var field = _a.field, meta = _a.meta;
        return (React.createElement(Container, null,
            label !== "" ? (React.createElement(Label, { htmlFor: containerId },
                label,
                meta.error && meta.touched ? (React.createElement(ErrorWrapper, { id: containerId + "Error" }, meta.error)) : null)) : null,
            React.createElement(RadioContainer, null, options.map(function (option) {
                var radioId = option + field.name;
                var checked = field.value === option;
                return (React.createElement(RadioItem, { key: option, checked: checked },
                    React.createElement(Radio, __assign({}, field, { id: radioId, value: option, checked: checked })),
                    React.createElement(RadioLabel, { htmlFor: radioId }, option)));
            }))));
    }));
};
//# sourceMappingURL=RadioList.js.map